import type { AxiosResponse } from 'axios';
import { adminAxios } from 'utils/adminAxios';
import { organizationAdminsApi } from './api';

export type OrganizationAdminsPermittedServicesType = Required<{
  quest: boolean;
  competition: boolean;
  dxCopilotPlanner: boolean;
  dxCopilotAnalytics: boolean;
}>;

export type OrganizationAdminsMeResponse = Required<{
  id: number;
  adminId: number;
  organizationId: number;
  organizationName: string;
  status: string;
  logoUrl: string | null;
  permittedServices: OrganizationAdminsPermittedServicesType;
}>;

export const getOrganizationAdminsMe = async (): Promise<AxiosResponse> => {
  return await adminAxios.get(`${organizationAdminsApi.path}/me`);
};
